<template>
  <div class="all-order">
    <div class="order-list" v-show="orderList.length">
      <list :finished="finished" @load="onLoad" finished-text="没有更多了" v-model="loading">
        <div :key="index" class="sku-details" v-for="(sku, index) in orderList">
          <a
            @click="jumpDetails(sku.item_id, sku.sku_id, sku.platform, sku.item_type)"
            class="jump-details"
            href="javascript:;"
          >
            <div class="sku-img">
              <img v-lazy="sku.pic_url" />
            </div>
            <div class="sku-desc">
              <div class="sku-intro">
                <div class="sku-title">{{sku.name}}</div>
                <div class="sku-name-num">
                  <div class="sku-name">
                    <span>
                      <em
                        :key="index"
                        v-for="(attr, index) in sku.attr_list"
                      >{{attr.attr_value.value}}</em>
                    </span>
                  </div>
                  <div class="sku-num">数量: {{sku.sku_num}}</div>
                </div>
                <div class="sku-platform">{{sku.platform_info.brand}}</div>
              </div>
            </div>
          </a>
          <div class="sku-status">
            <div class="status">
              <p v-show="sku.status === 103">该商品超过售后期</p>
            </div>
            <div class="sku-functional-btn">
              <button
                :disabled="sku.invoice_number <= 0"
                @click="applyAfterSaleHandler(sku)"
                class="apply-after-sale"
              >申请售后</button>
            </div>
          </div>
        </div>
      </list>
    </div>
    <no-data v-show="noData && !orderList.lnegth"></no-data>
    <transition name="fade-in">
      <component :is="componentId" :sku="checkedSku" @change="closeFillInfo" @touchmove.prevent></component>
    </transition>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { List } from 'vant'
import FillAfterSaleInfo from './FillAfterSaleInfo'
import NoData from './NoData'
import api from '../../utils/api'
let flag = false
export default {
  name: 'allOder',
  components: {
    List,
    FillAfterSaleInfo,
    NoData
  },
  data () {
    return {
      componentId: null,
      orderList: [],
      pageNum: 1,
      finished: false,
      loading: false,
      noData: false,
      checkedSku: {}
    }
  },
  created () {
    this.$toast.loading('加载中....')
    this.getOrderList(this.pageNum).then(() => {
      this.$toast.clear()
    })
  },
  methods: {
    ...mapActions('afterSale', [
      'getCheckSku'
    ]),
    closeFillInfo () {
      this.componentId = null
    },
    applyAfterSaleHandler (sku) {
      if (sku.invoice_number > 0) {
        this.checkedSku = sku
        this.getCheckSku(sku).then(() => {
          this.$router.push({ name: 'afterSaleType', query: { trade: sku.child_trade_id, skuid: sku.sku_id } })
        })
      }
    },
    onLoad () {
      if (flag) {
        return false
      }
      flag = true
      setTimeout(() => {
        this.getOrderList(++this.pageNum).then(() => {
          this.loading = false
          flag = false
        })
      }, 500)
    },
    async getOrderList (pageNum) {
      const res = await this.$axios.get(`api/refund/list/101/${pageNum}`)
      if (res.status === 200) {
        const { code, data, msg } = res.data
        if (code === 0) {
          this.orderList = [...this.orderList, ...data]
        } else if (code === 9006) {
          if (pageNum === 1) {
            this.noData = true
          }
          this.finished = true
        } else {
          this.$toast(msg)
        }
      }
    },

    async jumpDetails (goodsid, skuid, platform, type) {
      if (flag) {
        return false
      }
      flag = true
      await api.routeJump({ goodsid, skuid, platform, type })
      flag = false
    }
  }
}
</script>

<style lang="less" scoped>
.order-list {
  padding: 0 0.2rem;
  background-color: #fff;
}
.sku-details {
  padding: 0.38rem 0 0.16rem;
  border-bottom: 0.5px solid #dadada;
  .jump-details {
    display: flex;
    justify-content: space-between;
  }
  .sku-img {
    width: 2rem;
    height: 2rem;
  }
  .sku-desc {
    padding-right: 0.33rem;
  }
  .sku-intro {
    width: 4.5rem;
    height: 2rem;
    .flex-column-between;
    margin-left: 0.2rem;
    .sku-title {
      width: 3.03rem;
      .ellipsis2;
      font-size: @fz24;
      color: @base;
    }
    .sku-name-num {
      .flex-between;
      .sku-name {
        max-width: 3.03rem;
        font-size: @fz20;
        color: @sku-name;
        background-color: #f5f5f5;
        // border: 0.5px solid #cbcbcb;
        // border-radius: 0.04rem;
        .hairline-surround(@color: #cbcbcb, @radius: 0.04rem);
        .ellipsis;
        span {
          padding: 0.05rem 0.1rem;
        }
      }
      .sku-num {
        font-size: @fz24;
        color: @base;
      }
    }
    .sku-platform {
      font-size: @fz24;
      color: @c80;
    }
  }
  .sku-status {
    margin-top: 0.21rem;
    text-align: right;
    font-size: @fz24;
    color: @c80;
    .flex-between;
  }
  .sku-functional-btn {
    height: 0.68rem;
    text-align: right;
    button {
      width: 1.7rem;
      height: 0.68rem;
      // border: 0.5px solid #979797;
      // border-radius: 30px;
      .hairline-surround(@color: #979797, @radius: 40px);
      color: @base;
      font-size: @fz24;
      &:disabled {
        color: #d6d6d6;
        // border-color: #D6D6D6;
        .hairline-surround(@color: #d6d6d6, @radius: 40px);
      }
    }
  }
}
</style>
